import React, { ReactElement } from 'react'
import { ResponsiveScrollbars } from '../Scrollbars'
import { SearchResultsContainer } from './styled'

const SearchResults = ({ children }: ISearchResultsProps) => (
  <ResponsiveScrollbars autoHeight autoHeightMax={'50vh'} desktop={true}>
    <SearchResultsContainer>{children}</SearchResultsContainer>
  </ResponsiveScrollbars>
)

export interface ISearchResultsProps {
  children: ReactElement[]
}

export default SearchResults
